
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="giga-login">
    <div class="row">
      <div class="col-lg-6">
        <div class="giga-login_wrapper">
          <div class="giga-login_form">
            <h2 class="giga-login_title">{{ $t("sign_in") }}</h2>

            <form role="form" v-on:submit.prevent="doLogin()">
              <div class="giga-fields">
                <!-- EMAIL -->
                <div
                  class="giga-input_field full-field"
                  :class="{
                    'field-hasError': $v.login.$anyDirty && $v.login.$invalid,
                  }"
                >
                  <label class="input-field_label">Adresse E-mail</label>
                  <div class="input-field_area">
                    <input
                      type="text"
                      id="Login"
                      name="Login"
                      autofocus
                      :placeholder="$t('enter_your_email')"
                      v-model="$v.login.$model"
                    />
                  </div>
                  <div class="giga-login_errors" v-if="$v.login.$anyDirty && $v.login.$invalid">
                    <ul class="login-errors_list">
                      <li class="error-item" v-if="!$v.login.required">{{ $t("email_required") }}</li>
                    </ul>
                  </div>
                </div>

                <!-- PASSWORD -->
                <div
                  class="giga-input_field giga-password_field full-field"
                  :class="{
                    'field-hasError': $v.password.$anyDirty && $v.password.$invalid,
                  }"
                >
                  <label class="input-field_label">Mot de passe</label>
                  <div class="input-field_area">
                    <input
                      :type="fieldType"
                      id="password"
                      name="password"
                      v-model.trim="name"
                      :placeholder="$t('enter_password')"
                      v-model="$v.password.$model"
                    />
                    <button class="togglePassword" type="button" @click="switchPassword">
                      <svg v-if="fieldType == 'password'" data-v-9ec8ce46="" width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-9ec8ce46="" fill-rule="evenodd" clip-rule="evenodd" d="M11 0.5C6 0.5 1.73 3.61 0 8C1.73 12.39 6 15.5 11 15.5C16 15.5 20.27 12.39 22 8C20.27 3.61 16 0.5 11 0.5ZM11 13C8.24 13 6 10.76 6 8C6 5.24 8.24 3 11 3C13.76 3 16 5.24 16 8C16 10.76 13.76 13 11 13ZM11 5C9.34 5 8 6.34 8 8C8 9.66 9.34 11 11 11C12.66 11 14 9.66 14 8C14 6.34 12.66 5 11 5Z" fill="#132D48"></path></svg>
                      <svg v-else xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24"><path d="M23.821,11.181v0a15.736,15.736,0,0,0-4.145-5.44l3.032-3.032L21.293,1.293,18,4.583A11.783,11.783,0,0,0,12,3C4.5,3,1.057,9.261.179,11.181a1.969,1.969,0,0,0,0,1.64,15.736,15.736,0,0,0,4.145,5.44L1.293,21.293l1.414,1.414L6,19.417A11.783,11.783,0,0,0,12,21c7.5,0,10.943-6.261,11.821-8.181A1.968,1.968,0,0,0,23.821,11.181ZM6,12a5.99,5.99,0,0,1,9.471-4.885L14.019,8.567A3.947,3.947,0,0,0,12,8a4,4,0,0,0-4,4,3.947,3.947,0,0,0,.567,2.019L7.115,15.471A5.961,5.961,0,0,1,6,12Zm6,6a5.961,5.961,0,0,1-3.471-1.115l1.452-1.452A3.947,3.947,0,0,0,12,16a4,4,0,0,0,4-4,3.947,3.947,0,0,0-.567-2.019l1.452-1.452A5.99,5.99,0,0,1,12,18Z"/></svg>
                    </button>
                  </div> 
                  <div class="giga-login_errors" v-if="$v.password.$anyDirty && $v.password.$invalid">
                    <ul class="login-errors_list">
                      <li class="error-item">{{ $t("password_required") }}</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="giga-form_footer">
                <div class="giga-button">
                  <button
                    class="giga-green_button no-icon"
                    :disabled="$v.login.$invalid || $v.password.$invalid"
                    data-cy="submit"
                    type="submit"
                  >
                    Se connecter
                  </button>
                </div>
                <div class="giga-button giga-flex_end">
                  <b-button to="/forget-password" class="giga-no_bg_button">{{ $t("forgot_password") }}</b-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="row">
          <div class="giga-login_content">
          <div class="giga-login_content_box">
            <img src="@/assets/images/Gigawhat_Official_Logo.svg" alt="">
            <h2>Plateforme 360° de gestion des CEE</h2>
            <p>Découvrez la plateforme la plus complète du marché: création d'opérations, simulation de volumes, veille règlementaire, facturation en ligne.</p>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import eventBus from "@/shared/event.bus";

const DEFAULT_MODAL_NOTIFICATION = "default-modal-notification";

export default {
  name: "Login",
  components: {
    // ForgetPasswordModal
  },
  props: [],
  mounted() {
    eventBus.$on("okClick", () => {
      this.closeModal({ instance: this.$root, id: DEFAULT_MODAL_NOTIFICATION });
    });
    eventBus.$on("closeClick", () => {
      this.closeModal({ instance: this.$root, id: DEFAULT_MODAL_NOTIFICATION });
    });
  },
  data() {
    return {
      login: null,
      notificationContent: null,
      loading: false,
      password: '',
      fieldType: 'password'
    };
  },
  validations: {
    login: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapGetters("alert", ["getMessage"]),
  },
  methods: {
    ...mapActions("account", ["authenticate"]),
    ...mapActions("notification", ["openModal", "closeModal"]),
    doLogin() {
      if (!this.login || !this.password) {
        return;
      }
      this.loading = true;
      const { login, password } = this;
      this.authenticate({ login, password });
    },
    showModal() {
      const data = {
        id: DEFAULT_MODAL_NOTIFICATION,
        backdropClose: false,
        content: this.notificationContent,
        fontSize: "h3",
        instance: this.$root,
      };
      this.openModal(data);
    },
    switchPassword(){
      this.fieldType = this.fieldType === "password" ? "text" : "password";
    }
  },
  watch: {
    getMessage(newErrorMessage) {
      this.loading = false;
      if (newErrorMessage) {
        this.notificationContent = newErrorMessage;
        this.showModal();
      }
    },
  },
  beforeDestroy() {
    eventBus.$off("okClick");
    eventBus.$off("closeClick");
  },
};
</script>
